<template>
  <NotificationMessenger ref="notification" :message="notificationMessage" />

  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="linha" style="justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem">
          <h2>Inspeções de primeira peça</h2>
        </div>
      </div>
    </div>

    <div class="margem container">
      <div class="bloco margem">
        <div class="linha filtros-linha" style="flex-wrap: wrap; gap: 0.75rem; align-items: flex-end">
          <div class="coluna">
            <label>OP</label>
            <input type="text" v-model="filtroOp" placeholder="Número da OP" @keyup.enter="aplicarFiltro" />
          </div>
          <div class="coluna">
            <label>Status</label>
            <select v-model="filtroStatus">
              <option value="">Todos</option>
              <option value="approved">Peça aprovada</option>
              <option value="conditional_release">Liberação condicional</option>
            </select>
          </div>
          <div class="coluna">
            <label>De</label>
            <input type="date" v-model="filtroDtInicio" />
          </div>
          <div class="coluna">
            <label>Até</label>
            <input type="date" v-model="filtroDtFim" />
          </div>
          <button class="search-btn" @click="aplicarFiltro">Filtrar</button>
        </div>
      </div>
    </div>

    <div class="margem container">
      <div v-if="isLoading" class="loading">
        <div></div>
      </div>
      <div v-if="!isLoading" class="margem bloco container">
        <table class="tabela">
          <tbody>
            <tr>
              <th>Data/hora</th>
              <th>OP</th>
              <th>Produto</th>
              <th>Injetora</th>
              <th>Status</th>
              <th>Registrado por</th>
            </tr>
            <tr v-if="inspecoes.length === 0">
              <td colspan="6" style="text-align: center; padding: 12px">Nenhuma inspeção encontrada.</td>
            </tr>
            <tr
              v-for="item in inspecoes"
              :key="item.id"
              class="clicavel"
              @click="abrirDetalhe(item)"
            >
              <td>{{ formatDataHora(item.completed_at) }}</td>
              <td>{{ item.op_num || item.op_cod }}</td>
              <td>{{ formatProduto(item) }}</td>
              <td>{{ item.maquina_nome || "-" }}</td>
              <td>
                <span class="chip status-chip" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span>
              </td>
              <td>{{ item.colaborador?.nomeCompleto || "-" }}</td>
            </tr>
          </tbody>
        </table>

        <PaginationComponent
          v-if="inspecoes.length > 0"
          :current-page="paginationData.currentPage"
          :total-pages="paginationData.lastPage"
          :per-page="paginationData.perPage"
          :total="paginationData.total"
          :from="paginationData.from"
          :to="paginationData.to"
          @page-changed="handlePageChange"
          @per-page-changed="handlePerPageChange"
        />
      </div>
    </div>
  </section>

  <SimpleModal :show="modalDetalhe" @close="fecharDetalhe">
    <div v-if="inspecaoSelecionada" class="coluna" style="gap: 0.75rem; min-width: 320px; max-width: 560px">
      <h2 style="text-align: center">Detalhe da inspeção</h2>

      <div class="linha detalhe-linha">
        <div><strong>OP:</strong> {{ inspecaoSelecionada.op_num || inspecaoSelecionada.op_cod }}</div>
        <div><strong>Injetora:</strong> {{ inspecaoSelecionada.maquina_nome || "-" }}</div>
      </div>

      <div><strong>Produto:</strong> {{ formatProduto(inspecaoSelecionada) }}</div>
      <div><strong>Concluída em:</strong> {{ formatDataHora(inspecaoSelecionada.completed_at) }}</div>
      <div>
        <strong>Status:</strong>
        <span class="chip status-chip" :class="statusClass(inspecaoSelecionada.status)">{{
          statusLabel(inspecaoSelecionada.status)
        }}</span>
      </div>

      <div v-if="inspecaoSelecionada.divergence_motivo">
        <strong>Motivo da divergência:</strong>
        <p style="margin: 0.25rem 0 0">{{ inspecaoSelecionada.divergence_motivo }}</p>
      </div>

      <div v-if="inspecaoSelecionada.obs">
        <strong>Observação registrada:</strong>
        <p style="margin: 0.25rem 0 0">{{ inspecaoSelecionada.obs }}</p>
      </div>

      <div v-if="inspecaoSelecionada.colaborador">
        <strong>Registrado por:</strong> {{ inspecaoSelecionada.colaborador.nomeCompleto }}
      </div>

      <div v-if="inspecaoSelecionada.equipe?.length">
        <strong>Equipe:</strong>
        <ul style="margin: 0.25rem 0 0; padding-left: 1.25rem">
          <li v-for="membro in inspecaoSelecionada.equipe" :key="membro.id">{{ membro.nomeCompleto }}</li>
        </ul>
      </div>

      <div v-if="inspecaoSelecionada.fotos?.length">
        <strong>Fotos da peça:</strong>
        <div class="imagem-wrapper margem">
          <div v-for="foto in inspecaoSelecionada.fotos" :key="foto.id" class="imagem-container">
            <div class="imagem-inner">
              <img :src="getImageUrl(foto)" class="imagem-parametro" :alt="foto.nome_original" />
              <div class="bottom-img-bar">
                <a :href="getImageUrl(foto)" target="_blank" rel="noopener" class="segment">
                  <div class="icone-olho"></div>
                  <div>Ver</div>
                </a>
                <div class="segment clicavel" @click="downloadFile(foto)">
                  <div class="icone-download"></div>
                  <div>Download</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p v-else class="sem-fotos">Nenhuma foto anexada a esta inspeção.</p>
    </div>
  </SimpleModal>
</template>

<script>
import { SimpleModal, PaginationComponent } from "roboflex-thalamus-componentes-vue3-lib";
import PrimeiraPecaDataSource from "@/data/datasource/PrimeiraPecaDataSource";
import NotificationMessenger from "@/components/NotificationMessenger.vue";

export default {
  name: "InspecoesPrimeiraPeca",
  components: {
    SimpleModal,
    PaginationComponent,
    NotificationMessenger,
  },
  data() {
    return {
      notificationMessage: "",
      filtroOp: "",
      filtroStatus: "",
      filtroDtInicio: "",
      filtroDtFim: "",
      inspecoes: [],
      isLoading: false,
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        perPage: 25,
        total: 0,
        from: 0,
        to: 0,
      },
      modalDetalhe: false,
      inspecaoSelecionada: null,
    };
  },
  async mounted() {
    await this.carregarInspecoes();
  },
  methods: {
    getFilters() {
      const filters = {};
      if (this.filtroOp != null && String(this.filtroOp).trim() !== "") {
        filters.op = String(this.filtroOp).trim();
      }
      if (this.filtroStatus) filters.status = this.filtroStatus;
      if (this.filtroDtInicio) filters.dt_inicio = this.filtroDtInicio;
      if (this.filtroDtFim) filters.dt_fim = this.filtroDtFim;
      return filters;
    },
    async aplicarFiltro() {
      this.paginationData.currentPage = 1;
      await this.carregarInspecoes();
    },
    async carregarInspecoes() {
      this.isLoading = true;
      try {
        const { data, pagination } = await PrimeiraPecaDataSource.listar(
          this.paginationData.currentPage,
          this.paginationData.perPage,
          this.getFilters()
        );
        this.inspecoes = data;
        this.paginationData = { ...this.paginationData, ...pagination };
      } catch (err) {
        this.notificationMessage =
          err.response?.data?.message || err.response?.data?.error || err.message || "Erro ao carregar inspeções.";
      } finally {
        this.isLoading = false;
      }
    },
    async handlePageChange(page) {
      this.paginationData.currentPage = page;
      await this.carregarInspecoes();
    },
    async handlePerPageChange(perPage) {
      this.paginationData.perPage = perPage;
      this.paginationData.currentPage = 1;
      await this.carregarInspecoes();
    },
    abrirDetalhe(item) {
      this.inspecaoSelecionada = item;
      this.modalDetalhe = true;
    },
    fecharDetalhe() {
      this.modalDetalhe = false;
      this.inspecaoSelecionada = null;
    },
    formatProduto(item) {
      if (!item.produto_cod && !item.produto_desc) return "-";
      if (item.produto_cod && item.produto_desc) return `${item.produto_cod} - ${item.produto_desc}`;
      return item.produto_desc || item.produto_cod || "-";
    },
    formatDataHora(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString("pt-BR");
    },
    statusLabel(status) {
      if (status === "conditional_release") return "Liberação condicional";
      return "Peça aprovada";
    },
    statusClass(status) {
      return status === "conditional_release" ? "status-chip-condicional" : "bg-sucesso";
    },
    getImageUrl(foto) {
      const base = (process.env.VUE_APP_ROOT_STORAGE || "").replace(/\/$/, "");
      if (!foto?.caminho) return "";
      if (base) return `${base}/${foto.caminho}`;
      return `/storage/${foto.caminho}`;
    },
    async downloadFile(foto) {
      try {
        const response = await fetch(this.getImageUrl(foto));
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = foto.nome_original || "foto.jpg";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.notificationMessage = `Erro ao baixar foto: ${error.message || error}`;
      }
    },
  },
};
</script>

<style scoped>
.filtros-linha label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.detalhe-linha {
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-chip {
  margin: 0;
  font-weight: 600;
  white-space: nowrap;
}

.status-chip-condicional {
  background: hsl(32 88% 93%);
  color: hsl(32 52% 28%);
  border: 1px solid hsl(32 45% 78%);
}

:global(.dark) .status-chip-condicional {
  background: hsl(32 38% 22%);
  color: hsl(32 55% 88%);
  border-color: hsl(32 28% 36%);
}

.sem-fotos {
  margin: 0.5rem 0 0;
  font-size: 0.85rem;
  color: var(--cor-texto-secundario, #666);
}

.imagem-wrapper {
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: flex-start;
  overflow-x: auto;
  scroll-behavior: smooth;
  margin-top: 0.5rem;
}

.imagem-container {
  flex: 0 0 auto;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
  width: 220px;
}

.imagem-parametro {
  border-radius: 10px 10px 0 0;
  height: 220px;
  width: 100%;
  object-fit: cover;
  display: block;
  border-bottom: 1px solid var(--cor-separador);
}

.bottom-img-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #f9f9f9;
  font-size: 0.9rem;
  border-radius: 0 0 10px 10px;
}

.segment {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 0.35rem 0;
}

.segment:hover {
  cursor: pointer;
  color: var(--cor-primaria-forte);
}
</style>
